import React, { Component } from 'react';
import { Button, Menu } from 'antd';
const { SubMenu } = Menu;
import { Link } from 'react-router-dom';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import logoImg from '@/assets/img/logo.svg';
import './header.css';

/**
 * 头部Header 组件
 */
export default class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
  }

  render() {
    const { curNav } = this.props;
    return (
      <div className="top-nav">
        <div style={{ width: 1000, height: '100%', margin: '0 auto' }}>
          <div className="left">

          </div>
          <div className="right">
            <ul>
              <li className={curNav == '/index' ? 'active' : ''}>
                <Link to="/index">首页</Link>
              </li>
              <li className={curNav == '/article' ? 'active' : ''}>
                <Link to="/article">我的文章</Link>
              </li>
              <li className={curNav == '/collect' ? 'active' : ''}>
                <Link to="/collect">收藏网址</Link>
              </li>
              <li className={curNav == '/about' ? 'active' : ''}>
                <Link to="/about">关于我</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}